import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from "framer-motion";
import {INumberAnimation} from "../../../../interfaces/information/INumberAnimation";

const variants = {
    enter: (direction: number) => ({
        y: direction > 0 ? 10 : -10,
        opacity: 0,
    }),
    center: {
        y: 0,
        opacity: 1,
    },
    exit: (direction: number) => ({
        y: direction > 0 ? -10 : 10,
        opacity: 0,
    }),
};

const NumberAnimation = ({value, className}: INumberAnimation) => {
    const previousValue = useRef(value);
    const direction = value >= previousValue.current ? 1 : -1;

    useEffect(() => {
        previousValue.current = value;
    }, [value]);

    return (
        <span className={`number-animation ${className ? className : ""}`}>
            <AnimatePresence mode="popLayout" initial={false} custom={direction}>
                <motion.span
                    className='number-animation-span'
                    key={value}
                    custom={direction}
                    variants={variants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{
                        duration: 0.2,
                        ease: "easeOut",
                    }}
                >
                    {value}
                </motion.span>
            </AnimatePresence>
        </span>
    );
};

export default NumberAnimation;